module.exports = __webpack_public_path__ + "media/images/icon_flash-2df0c6561c0ab16db692af88955fc24b.svg";